import UserApi from '@/services/api/core/UserApi'
import { useStore } from '@/store/store'

export function useApi(): UserApi {
  let store = useStore()

  return store.state.api.userApi
}
